/** Tiny embed helpers — keep out of `common.tsx` so App boot doesn't pull html-to-image. */

export function ShowEWChat(): void {
    const clientId = process.env.REACT_APP_TALK_TO_AGENT_KEY || "";
    const widgetAddress = process.env.REACT_APP_WIDGET_ADDRESS || "";
    if (!clientId || !widgetAddress) {
        return;
    }

    const existing = document.getElementById("ew-widgets");
    if (existing) {
        existing.setAttribute("data-client-id", clientId);
        existing.style.display = "";
        return;
    }

    const scriptId = "ew-admin-chat-embed";
    const existingScript = document.getElementById(scriptId);
    if (existingScript) {
        existingScript.remove();
    }

    const myScript = document.createElement("script");
    myScript.id = scriptId;
    myScript.async = true;
    myScript.setAttribute(
        "src",
        `${widgetAddress}/embed.emailwish.js?v=0.3&client-id=${clientId}&shop=ankit-dev.myshopify.com`
    );
    document.body.appendChild(myScript);
}

export function hideChat(): void {
    const EW_bot = document.getElementById("ew-widgets");
    if (EW_bot) {
        EW_bot.remove();
    }
    const embedScript = document.getElementById("ew-admin-chat-embed");
    if (embedScript) {
        embedScript.remove();
    }
}
